$(document).ready(function () {
    var $ = jQuery.noConflict();
    $("#SearchForm_SearchForm_Location").select2({
        templateResult: function (data, container) {
            if (data.element) {
                if ($(data.element).attr('child-item') === 'true') {
                    $(container).css('padding-left', '1rem');
                }
            }
            return data.text;
        }
    });
});

// customSelect();
//
// function customSelect(){
//     $('#SearchForm_SearchForm_Location').each(function(){
//         $(this).select2({
//             templateResult: function (data, container) {console.log(data.element)
//                 if (data.element) {
//                     if ($(data.element).attr('child-item') === 'true') {
//                         $(container).css('padding-left', '1rem');
//                     }
//                 }
//                 return data.text;
//             }
//         });
//     });
// }
